import React, { useEffect } from 'react';
import PageHeader from '../../../components/PageHeader';
import { FORWARD_LOOKING_ALERTS } from '../data/forwardLookingAlerts';

const FILINGS_ALERTS_PATH = '/competitors/alerts';

export default function Alerts() {
  useEffect(() => {
    sessionStorage.setItem('comply_last_filings_path', FILINGS_ALERTS_PATH);
    sessionStorage.setItem('comply_active_filings_tab', 'Alerts');
  }, []);

  return (
    <>
      <PageHeader title="State Insurance Filings" />
      <div className="body">
        <div className="table-area alerts-panel">
          <div className="report-outer report-outer--embedded">
            <div className="report-scope">
              <div className="report-page report-outer--flush">
                <div className="report-card product-depth-panel forward-looking-alerts-panel">
                  <div className="chart-panel__header">
                    <h3 className="report-card-title forward-looking-alerts-panel__title">
                      Forward-looking Alerts
                    </h3>
                  </div>
                  <div className="forward-looking-alerts-panel__body">
                    {FORWARD_LOOKING_ALERTS.map((alert) => (
                      <div key={alert.id} className="product-depth-row forward-looking-alert-row">
                        <div className="product-depth-row__category forward-looking-alert-row__label">
                          <span
                            className={`forward-looking-alert__badge forward-looking-alert__badge--${alert.colorKey}`}
                          >
                            {alert.company}
                          </span>
                        </div>
                        <div className="product-depth-row__bars forward-looking-alert__copy">
                          {alert.paragraphs.map((paragraph, paragraphIndex) => (
                            <p key={`${alert.id}-${paragraphIndex}`} className="forward-looking-alert__desc">
                              {paragraph}
                            </p>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
